var _style, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle4, _circle5, _circle6, _circle7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtOtp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    role: "img",
    "aria-label": "Animated one-time code illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "One-time code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .dot {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: fill 5s cubic-bezier(0.34, 1.4, 0.45, 1) infinite;\n    }\n    .d-1 { animation-delay: 0s; }\n    .d-2 { animation-delay: 0.16s; }\n    .d-3 { animation-delay: 0.32s; }\n    .d-4 { animation-delay: 0.48s; }\n    @keyframes fill {\n      0%, 12%   { transform: scale(0); }\n      26%, 76%  { transform: scale(1); }\n      88%, 100% { transform: scale(0); }\n    }\n\n    .caret {\n      transform-box: fill-box;\n      animation: caret 5s ease-in-out infinite;\n    }\n    @keyframes caret {\n      0%, 10%   { transform: translateX(0);    opacity: 1; }\n      18%, 26%  { transform: translateX(32px); opacity: 1; }\n      34%, 42%  { transform: translateX(64px); opacity: 1; }\n      50%       { transform: translateX(96px); opacity: 1; }\n      58%, 100% { transform: translateX(96px); opacity: 0; }\n    }\n\n    .badge {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: pop 5s cubic-bezier(0.34, 1.45, 0.45, 1) infinite;\n    }\n    @keyframes pop {\n      0%, 58%   { transform: scale(0); opacity: 0; }\n      68%       { transform: scale(1.14); opacity: 1; }\n      74%, 82%  { transform: scale(1); opacity: 1; }\n      90%, 100% { transform: scale(0); opacity: 0; }\n    }\n\n    .tick {\n      stroke: #ffffff; stroke-width: 3.2; fill: none;\n      stroke-linecap: round; stroke-linejoin: round;\n      stroke-dasharray: 22;\n      animation: tick 5s ease-out infinite;\n    }\n    @keyframes tick {\n      0%, 64%   { stroke-dashoffset: 22; }\n      74%, 86%  { stroke-dashoffset: 0; }\n      90%, 100% { stroke-dashoffset: 22; }\n    }\n\n    .mote { animation: drift 6s ease-in-out infinite; }\n    .mote-2 { animation-duration: 7.5s; animation-delay: -2s; }\n    .mote-3 { animation-duration: 8.5s; animation-delay: -4s; }\n    @keyframes drift {\n      0%, 100% { transform: translateY(0); opacity: 0.55; }\n      50%      { transform: translateY(-7px); opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .dot, .caret, .badge, .tick, .mote { animation: none; }\n      .dot { transform: scale(1); }\n      .caret { opacity: 0; }\n      .badge { transform: scale(1); opacity: 1; }\n      .tick { stroke-dashoffset: 0; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mote",
    cx: 20,
    cy: 60,
    r: 3.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-2",
    cx: 182,
    cy: 46,
    r: 4.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-3",
    cx: 30,
    cy: 172,
    r: 3,
    fill: "#ffffff",
    opacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 144,
    height: 88,
    rx: 16,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 68,
    width: 22,
    height: 22,
    rx: 7,
    fill: "#eaf3fb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 74.5,
    width: 13,
    height: 9.5,
    rx: 2,
    fill: "none",
    stroke: "#2b8fe0",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 75.5 L55 80.5 L61.5 75.5",
    fill: "none",
    stroke: "#2b8fe0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 71,
    width: 54,
    height: 6,
    rx: 3,
    fill: "#d7e2ee"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 82,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#e6edf5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 102,
    width: 26,
    height: 28,
    rx: 8,
    fill: "#f2f7fb",
    stroke: "#e2ebf3",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 102,
    width: 26,
    height: 28,
    rx: 8,
    fill: "#f2f7fb",
    stroke: "#e2ebf3",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 102,
    width: 26,
    height: 28,
    rx: 8,
    fill: "#f2f7fb",
    stroke: "#e2ebf3",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 102,
    width: 26,
    height: 28,
    rx: 8,
    fill: "#f2f7fb",
    stroke: "#e2ebf3",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "caret",
    x: 51,
    y: 109,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#2b8fe0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-1",
    cx: 52,
    cy: 116,
    r: 4.5,
    fill: "#2b8fe0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-2",
    cx: 84,
    cy: 116,
    r: 4.5,
    fill: "#2b8fe0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-3",
    cx: 116,
    cy: 116,
    r: 4.5,
    fill: "#2b8fe0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-4",
    cx: 148,
    cy: 116,
    r: 4.5,
    fill: "#2b8fe0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "badge"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 148,
    r: 18,
    fill: "#0f9d63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 148,
    r: 18,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M144.8 148.5 L150 154 L159.6 143.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtOtp);
export default __webpack_public_path__ + "static/media/art-otp.1b03433f100597f13ab5f0105cac3269.svg";
export { ForwardRef as ReactComponent };